import React, { useState, useEffect } from "react";
import styles from "./TemplateHero23.module.css";

const TemplateHero23 = ({ branding, heroData }) => {
  const [current, setCurrent] = useState(0);
  const [prev, setPrev] = useState(null);
  const [dir, setDir] = useState(1);

  const slides = heroData?.slides || [];

  const goTo = (index) => {
    if (index === current) return;

    setDir(index > current ? 1 : -1);
    setPrev(current);
    setCurrent(index);

    setTimeout(() => setPrev(null), 700);
  };

  useEffect(() => {
    if (slides.length <= 1) return;

    const t = setInterval(() => {
      goTo((current + 1) % slides.length);
    }, 5500);

    return () => clearInterval(t);
  }, [current, slides.length]);

  if (!slides.length) return null;

  return (
    <div className={styles.root}>
      {slides.map((s, i) => (
        <div
          key={i}
          className={`${styles.slide} ${
            i === current ? styles.active : i === prev ? styles.leaving : ""
          }`}
          style={{ backgroundImage: `url('${s.image}')` }}
        />
      ))}

      <div className={styles.overlay} />

      {/* LEFT BAR */}
      <div className={styles.leftbar}>
        <div className={styles.logoDot} />

        <span className={styles.slideNum}>
          0{current + 1} — 0{slides.length}
        </span>

        <div className={styles.sideDots}>
          {slides.map((_, i) => (
            <div
              key={i}
              className={`${styles.sdot} ${
                i === current ? styles.activeDot : ""
              }`}
              onClick={() => goTo(i)}
            />
          ))}
        </div>
      </div>

      {/* CONTENT */}
      <div className={styles.content}>
        <div className={styles.text}>
          <span className={styles.tag}>
            {branding?.companyName || "Premium Travel"}
          </span>

          <h1 className={styles.title}>{slides[current].title}</h1>

          <p className={styles.sub}>{slides[current].subtitle}</p>
        </div>

        <div className={styles.right}>
          <div className={styles.arrows}>
            <button
              className={styles.arrow}
              onClick={() =>
                goTo((current - 1 + slides.length) % slides.length)
              }
            >
              ←
            </button>

            <button
              className={styles.arrow}
              onClick={() => goTo((current + 1) % slides.length)}
            >
              →
            </button>
          </div>

          <button className={styles.cta}>Explore Now</button>
        </div>
      </div>
    </div>
  );
};

export default TemplateHero23;